<template>
    <div class="">
        <base-nav class="bg-gradient-primary text-white" type="" transparent effect="" expand>
            <a class="navbar-brand text-white" @click.prevent="getStats" href="/dashboard/sync/"><small class="fas fa-sync"></small></a>

            <div class="row" slot="content-header">
                <div class="col-6 collapse-brand">
                    <router-link :to="{name: 'home'}" class="" slot-scope="{closeMenu}">
                        <img v-lazy="'img/brand/sic.png'" class="">
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav ml-auto pr-8">
                <base-dropdown tag="li" :title="'Hi ' + this.username">
                    <router-link class="dropdown-item" :to="{name: 'user-profile'}"><i class="ni ni-single-02 text-yellow"></i> Profile</router-link>
                    <router-link class="dropdown-item" :to="{name: 'website'}"><i class="ni ni-world text-primary"></i> Website Settings</router-link>
                    <div class="dropdown-divider"></div>
                    <a @click.prevent="logoutUser" class="dropdown-item" href="/logout"><i
                            class="ni ni-button-power text-danger"></i>
                        Logout</a>
                </base-dropdown>
            </ul>
        </base-nav>
        <div class="header bg-gradient-primary pt-3 pb-5">
            <div class="container-fluid">
                <div class="header-body">
                    <!-- Card stats -->
                    <div class="row">
                        <div class="col-xl-3 col-lg-6">
                            <div class="card card-stats mb-4 mb-xl-0">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="card-title text-uppercase text-muted mb-0">Users</h5>
                                            <span class="h2 font-weight-bold mb-0">{{stats.users}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                                                <i class="fas fa-users"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6">
                            <div class="card card-stats mb-4 mb-xl-0">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="card-title text-uppercase text-muted mb-0">Students</h5>
                                            <span class="h2 font-weight-bold mb-0">{{stats.students}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                                                <i class="ni ni-hat-3"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6">
                            <div class="card card-stats mb-4 mb-xl-0">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="card-title text-uppercase text-muted mb-0">Startups</h5>
                                            <span class="h2 font-weight-bold mb-0">{{stats.companies}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                                                <i class="ni ni-briefcase-24"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6">
                            <div class="card card-stats mb-4 mb-xl-0">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="card-title text-uppercase text-muted mb-0">Ideas</h5>
                                            <span class="h2 font-weight-bold mb-0">{{stats.ideas}}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                                                <i class="ni ni-bulb-61"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import axios from "axios";
import router from "../router";

export default {
  name: "AppHeader",
  data() {
    return {
      stats: {},
      username: ""
    };
  },
  mounted() {
    this.username = localStorage.getItem("user_username");
    this.getStats();
  },
  methods: {
    getStats() {
      axios({
        method: "get",
        url: "admin/stats?access_token=" + localStorage.getItem("access_token"),
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.stats = result.data;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    logoutUser() {
      axios({
        method: "post",
        url: "admin/logout",
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("expiration_date");
            localStorage.removeItem("user_fullName");
            localStorage.removeItem("user_username");
            console.log(result);
            router.push({ path: "/" });
            window.location.reload(true);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
.events {
  padding-top: 20px;
}
</style>
